/* React */
import React, { useEffect, useState } from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/redux/store";

/* Thunks */
import { fetchGlossary } from "src/redux/thunks/glossary/glossaryThunk";

/* Utils */
import PageWrapper from "src/utils/wrapper/page-wrapper/PageWrapper";
import PageLayoutWrapper from "src/utils/wrapper/page-layout-wrapper/PageLayoutWrapper";

/* Components */
import Toolbar from "src/components/glossary/toolbar/Toolbar";
import ContentContainer from "src/components/glossary/content-container/ContentContainer";
import PaginationContainer from "src/components/glossary/pagination-container/PaginationContainer";

/* Stylesheet */
import styles from "./Glossary.module.scss";

/* Interfaces */
import { GlossaryProps } from "src/shared/interfaces/common/Glossary";

const Glossary: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [entries, setEntries] = useState<
    GlossaryProps[] | undefined
  >(undefined);

  useEffect(() => {
    dispatch(fetchGlossary()).then((action) => {
      if (fetchGlossary.fulfilled.match(action)) {
        setEntries(action.payload);
      }
    });
  }, [dispatch]);

  return (
    <PageWrapper>
      <PageLayoutWrapper
        scssProps={{
          padding: "32px 0px 32px 0px",
          height: "100%",
        }}
      >
        <h1 className={styles.title}>Glossary</h1>
        <Toolbar />
        <ContentContainer entries={entries} />
        <PaginationContainer />
      </PageLayoutWrapper>
    </PageWrapper>
  );
};

export default Glossary;
